import moment from "moment";
import { DATA_TYPES } from "src/infinode/constants/data";

// For testing
const getFixedDatePayload = dataRequestPayload => {
  dataRequestPayload.startDateTime = "2021-10-30T08:00:00.000Z";
  dataRequestPayload.endDateTime = "2021-11-08T08:00:00.000Z";
  console.log(`fixed date payload : start : ${moment(dataRequestPayload.startDateTime).format()}`);
  console.log(`fixed date payload : end : ${moment(dataRequestPayload.endDateTime).format()}`);
  return dataRequestPayload;
};

const actions = {
  DATA_ERROR: "DATA_ERROR",
  GET_DATA_REQUEST: "GET_DATA_REQUEST",
  GET_DATA_SUCCESS: "GET_DATA_SUCCESS",

  getCurrentData: (token, dataRequestPayload, dataType = DATA_TYPES.ENERGY) => {
    return {
      type: actions.GET_DATA_REQUEST,
      token,
      dataRequestPayload: dataRequestPayload,
      isCurrentData: true,
      dataType
    };
  },

  getCompareData: (token, dataRequestPayload, dataType = DATA_TYPES.ENERGY) => {
    return {
      type: actions.GET_DATA_REQUEST,
      token,
      dataRequestPayload: dataRequestPayload,
      isCurrentData: false,
      dataType
    };
  }
};

const dataActions = actions;

export default dataActions;
